import React from 'react';
import {
  FilterAndSortContainer,
  FilterContainer,
  FilterLine
} from '../FilterSort/style.js';
import Loader from '../Loader';
import {
  CompletedPageContainer,
  HeadingAndFilterCon,
  InnerContainer,
  LeftContentContainer,
  MainContainer
} from './style.js';

import RoundedDropDown from '../../components2/RoundedDropDown/index.jsx';
import SortItems from '../../components2/SortItems/index.jsx';
import { getTasksWithClasses } from '../../service/tasks.js';
import { getUserRole } from '../../userLocalDetails.js';
import { arrayFromArrayOfObject } from '../../utils/arrays.js';
import ImprovedSecondarySideBar from '../ImprovedSecondarySideBar/index.jsx';
import MenuButton from '../MenuButton/index.jsx';
import { isTabletView } from '../ReactiveRender/index.jsx';
import {
  useAssignmentsAll,
  useClassData,
  useCompletedAll,
  useProfile,
} from '../state/hooks.js';
import TaskHistoryDataComponent from './TaskHistoryDataComponent.jsx';

export default function CompletedPage() {

  const [sortItem, setSortItem] = React.useState(true);
  const [selectedClass, setSelectedClass] = React.useState('');
  const [isShowMenu, setShowMenu] = React.useState(false);
  const tabletView = isTabletView();
  const isTeacher = getUserRole() === 'TEACHER';
  const { data: classData, isLoadingdata: isLoadingclassData } = useClassData();
  const { data: profile, isLoadingdata: isLoadingProfile } = useProfile();

  const { data: allAssignmentData, isLoadingdata: isAllAssignmentDataLoading } =
  useAssignmentsAll();
  const { data: allCompletedData, isLoadingdata: isAllCompletedDataLoading } =  
  useCompletedAll();

  const enhanceTasksWithClassInfo = (filteredTasks) => {
    return getTasksWithClasses(filteredTasks, classData)
  };

  const getFilteredTasks = () => {
    if (getUserRole() === 'TEACHER') {
      return allAssignmentData?.filter(task => 
        task.status === "CLOSED"
      );
    }
    return allCompletedData;
  }

  
  const filteredTasks = getFilteredTasks();
  const tasks = enhanceTasksWithClassInfo(filteredTasks);
  const setSelectedValue = (type, selectValue) => {
    if (type === 'classes') {
      setSelectedClass(selectValue);
    }
  };

  const filterData = (tasks) => {
    const filteredTasks = tasks.filter(
      (task) => !selectedClass || task.classTitle === selectedClass,
    );

    const sortedTasks = filteredTasks.sort((a, b) => {
      const dateA = new Date(a.closedAt || a.completedAt ).getTime();
      const dateB = new Date(b.closedAt || b.completedAt ).getTime();
      return sortItem ? dateB - dateA : dateA - dateB;
    });

    return sortedTasks;
  };

  if (
    isLoadingclassData ||
    isAllAssignmentDataLoading ||
    isLoadingProfile ||
    isAllCompletedDataLoading
  ) {
    return <Loader />;
  }

  return (
    <CompletedPageContainer>
      <MainContainer>
        <ImprovedSecondarySideBar
          isShowMenu={isShowMenu}
          setShowMenu={setShowMenu}
        />
        <InnerContainer>
          <HeadingAndFilterCon>
            {tabletView && <MenuButton setShowMenu={setShowMenu} />}
            <FilterAndSortContainer>
              <FilterContainer>
                <RoundedDropDown
                  search={false}
                  type={'classes'}
                  selectedIndex={setSelectedValue}
                  menuItems={arrayFromArrayOfObject(tasks, 'classTitle')}
                  defaultValue={selectedClass}
                  width={110}
                />
              </FilterContainer>
              <FilterLine />
              <SortItems
                sortItem={sortItem}
                setSortItem={setSortItem}
                firstSortText={'New to Old'}
                secondSortText={'Old to New'}
              />
            </FilterAndSortContainer>
          </HeadingAndFilterCon>
          <LeftContentContainer>
            <TaskHistoryDataComponent list={filterData(tasks)} />
          </LeftContentContainer>
        </InnerContainer>
      </MainContainer>
    </CompletedPageContainer>
  );
}